import { API } from 'src/utils/interceptor'

const pathFor = venueId => `venue/${venueId}/invoice-forward`

export const readInvoiceForwardSettings = async venueId => {
  const response = await API.get('api2', pathFor(venueId))
  return response?.data
}

export const saveInvoiceForwardSettings = async (venueId, payload) => {
  const response = await API.put('api2', pathFor(venueId), { body: payload })
  return response?.data
}

export const sendInvoiceForwardTestEmail = async venueId => {
  const response = await API.post('api2', `${pathFor(venueId)}/test`, {
    body: {},
  })
  return response
}

export const emailInvoice = async invoiceId => {
  const response = await API.post('api2', `invoices/${invoiceId}/forward`, {
    body: {},
  })
  return response
}

export const sendRecentInvoiceForwards = async venueId => {
  const response = await API.post('api2', `${pathFor(venueId)}/recent`, {
    body: {},
  })
  return response?.data
}
